module.exports = __webpack_public_path__ + "img/b2d513a.png";